import { Dictionary } from '../../../../types/globals';

export interface BrandsResponse {
    success: boolean;
    errors: [];
    data: BrandsResponseFromApi[];
}

export enum BrandActionsTypes {
    RESPONSE = 'RESPONSE',
}
export interface BrandsAction {
    type: BrandActionsTypes;
    response: BrandsResponse;
}

export interface BrandsResponseFromApi {
    /* eslint-disable @typescript-eslint/camelcase, camelcase */
    name: string;
    id_catalog_brand: string;
    url_key: string;
    /* eslint-enable @typescript-eslint/camelcase, camelcase */
}

export interface BrandData {
    catalogBrandId: string;
    name: string;
    urlKey?: string;
}

export interface BrandsState {
    brands: BrandData[];
    brandEntities: Dictionary<string> | {};
}
